import React from "react";
import * as pdfjs from "pdfjs-dist/webpack";
import Uppy from "@uppy/core";
import { Dashboard } from "@uppy/react";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import Mammoth from "mammoth";

// Component to extract text from PDF and DOCX files
const PdfTextExtractor = ({ setPdfText, setTextView, uppyHeight = 190 }) => {
  const uppy = React.useMemo(() => {
    console.info("Initializing Uppy instance");
    return new Uppy({
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: [".pdf", ".docx"],
      },
      autoProceed: true,
    });
  }, []);

  React.useEffect(() => {
    // Handle file upload and text extraction
    const handleFileAdded = async (file) => {
      console.info("Processing uploaded file:", file.name);
      try {
        const arrayBuffer = await file.data.arrayBuffer();

        if (file.extension === "pdf") {
          console.info("Extracting text from PDF");
          const pdf = await pdfjs.getDocument(arrayBuffer).promise;
          let text = "";

          for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const content = await page.getTextContent();
            const pageText = content.items.map((item) => item.str).join(" ");
            text += `${pageText}\n\n`;
          }

          setPdfText(text);
        } else if (file.extension === "docx") {
          console.info("Extracting text from DOCX");
          const result = await Mammoth.extractRawText({ arrayBuffer });
          setPdfText(result.value);
        }
      } catch (error) {
        console.error("Error extracting text from file:", error);
        setPdfText("Failed to extract text from the file.");
      }
    };

    // Handle file removal or cancel
    const handleFileRemoved = () => {
      console.info("File removed or upload canceled");
      setPdfText("");
    };

    uppy.on("file-added", handleFileAdded);
    uppy.on("file-removed", handleFileRemoved);

    return () => {
      console.info("Cleaning up Uppy listeners");
      uppy.off("file-added", handleFileAdded);
      uppy.off("file-removed", handleFileRemoved);
    };
  }, [uppy, setPdfText, setTextView]);

  return (
    <Dashboard
      uppy={uppy}
      height={uppyHeight}
      hideUploadButton
      proudlyDisplayPoweredByUppy={false}
    />
  );
};

export default PdfTextExtractor;
